<template>
  <div class="container-fluid">
    
      
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";

export default {
  name: 'acessoDireto',
  data() {
    return {
      
    };
  },
  created() {
   LoginService.acessoDireto().then(
        (data) => {
          //You can get warning (error: 'data' is defined but never used;), if you don't use parameters;
          console.log(data);
          const homePage = LoginService.currentUserValue.homePage;
          this.$router.push(homePage);
        },
        (error) => {
          console.log(error);
          this.erro = "Problema ao autenticar com certificado digital!";
          this.$router.push({ path: "/login", params: { erro: '6'}});
        }
      );
  },
  methods: {
   
  },
};
</script>
